<template>
  <app-modal v-bind="$attrs" class="confirm-modal-container" :title="title">
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <div class="modal-body msg-pre-line pa-4">{{ message }}</div>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <template v-if="isClose">
              <v-btn @click="cancel" variant="outlined">閉じる</v-btn>
            </template>
            <template v-else>
              <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
              <v-btn @click="cancel" variant="outlined">いいえ</v-btn>
            </template>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

export default defineComponent({
  name: "ConfirmModal",
  props: {
    message: {
      type: String as PropType<string>,
      required: true,
    },
    title: {
      type: String as PropType<string>,
      default: "確認",
    },
    isClose: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.msg-pre-line {
  white-space: pre-line;
}
</style>
